import React, { useMemo } from 'react';
import { compose } from 'redux';
import { withStyles } from '@material-ui/core';
import SelectField from './SelectField';
import { useTranslation } from 'react-i18next';

const styles = (theme) => ({
	root: {
		[theme.breakpoints.up('md')]: {
			width: '30rem',
		},
		'&>div': {
			margin: 0,
			marginTop: '6px',
		},

		marginTop: '30px',
		[theme.breakpoints.up('md')]: {
			marginTop: '0',
		},
	},
	select: {
		cursor: 'pointer',
	},
});

const THEME_ORDER = [
	'Het Kappersvak',
	'Hoofdhuid- en haarverzorging',
	'Knippen',
	'Snijden',
	'Kleuren',
	'Tijdelijk omvormen',
	'Blijvend omvormen',
	'Vlechten en opsteken',
	'Herenvaktechniek',
	'Barbiersvak',
	'Huid- en haarverzorging',
	'Basistechnieken',
	'Barbierstechnieken',
	'Baardvormgeving en scheren',
	'Omvormen',
];

const Filter = (props) => {
	const { classes, activeTags = [], initialValue = [] } = props;
	const { t } = useTranslation();

	const options = useMemo(() => activeTags.map((tag) => ({
		id: tag.id,
		label: tag.name,
		icon: tag.image || '',
	})).sort((a, b) => {
		const ia = THEME_ORDER.findIndex((t) => t.toLowerCase() === a.label.toLowerCase());
		const ib = THEME_ORDER.findIndex((t) => t.toLowerCase() === b.label.toLowerCase());
		if (ia === -1 && ib === -1) return 0;
		if (ia === -1) return 1;
		if (ib === -1) return -1;
		return ia - ib;
	}), [activeTags]);

	const handleChange = (data) => {
		if (props.onChange) props.onChange(data);
	};

	console.log("optinos", options)
	if (!activeTags) return null;
	return (
		<div className={classes.root}>
			<SelectField
				label={t('app.dashboard.fields.themes.label')}
				onChange={handleChange}
				options={options}
				initialValue={initialValue}
			/>
		</div>
	);
};

export default compose(
	withStyles(styles, { name: 'AppDashboardFilter' }),
)(Filter);
